import type { QrDimensionFunction, QrDimensions } from 'html5-qrcode/esm/core'

export const minimumQrboxSize = 50

export const clampQrbox = (
  dimensions: QrDimensions,
  viewfinderWidth: number,
  viewfinderHeight: number
): QrDimensions => {
  if (
    viewfinderWidth < minimumQrboxSize ||
    viewfinderHeight < minimumQrboxSize
  ) {
    return dimensions
  }

  return {
    width: Math.min(
      Math.max(dimensions.width, minimumQrboxSize),
      viewfinderWidth
    ),
    height: Math.min(
      Math.max(dimensions.height, minimumQrboxSize),
      viewfinderHeight
    )
  }
}

export const normalizeQrbox = (
  qrboxConfig: QrDimensionFunction | number
): QrDimensionFunction | number => {
  if (typeof qrboxConfig === 'number') {
    return Math.max(qrboxConfig, minimumQrboxSize)
  }

  return (viewfinderWidth, viewfinderHeight) =>
    clampQrbox(
      qrboxConfig(viewfinderWidth, viewfinderHeight),
      viewfinderWidth,
      viewfinderHeight
    )
}
